{
    // BUTTONS
    const CHANGE_ADDRESS = 'change-address-button';
    const CANCEL = 'cancel-button';
    const ACCEPT_AND_RESEND = 'accept-and-resend-button';
    const RESEND = 'resend-button';
    const TOGGLE_COLLAPSE = 'collapse-toggle';

    // FORM DATA
    const EMAIL_OR_TELEPHONE_CHANGED = 'email-or-telephone-changed';


    $(() => {
        const handleClick = (...buttons) => (handler) => {
            const selector = buttons
                .flatMap((btn) => [
                    `.update-order-details .${btn}`,
                    `.updateorderdetails-form .${btn}`
                ])
                .join(', ');

            $(selector).on('click', handler);
        };

        handleClick(CHANGE_ADDRESS, CANCEL)((event) => {
            const $button = getButton(event);

            toggleEmailAndTelephoneEditing($button);
        });

        handleClick(ACCEPT_AND_RESEND, RESEND)((event) => {
            const $button = getButton(event);
            const $orderRow = $button.closest('.update-order-row');
            const $form = $orderRow.find('form');
            const emailOrTelephoneChanged = $button.hasClass(ACCEPT_AND_RESEND);

            if (emailOrTelephoneChanged) {
                $form.data(EMAIL_OR_TELEPHONE_CHANGED, true);
            }

            // Expand panel
            $button.closest('.update-order-row-panel').removeClass('panel-collapsed');

            // Hide messages
            $orderRow.removeClass('update-successful');
            $orderRow.removeClass('update-failed');

            $form.submit();
        });

        function getButton(event) {
            return $(event.currentTarget);
        }

        handleClick(TOGGLE_COLLAPSE)((event) => {
            const $toggleBtn = getButton(event);
            $toggleBtn.closest('.update-order-row-panel').toggleClass('panel-collapsed');

            // Hide messages
            $toggleBtn.closest('.update-order-row').removeClass('update-successful');
            $toggleBtn.closest('.update-order-row').removeClass('update-failed');
        });
    });


    Object.assign(window, {
        validateEmailAddressOrTelephoneForUpdateOrderDetails() {
            const $form = $(this);

            if (!$form.valid()) {
                return false;
            }
        },

        successChangeEmailOrTelephoneForSalesOrderItem({ EmailAddress, CompleteTelephone, Telephone, CallingCode, Outcome, Message }) {
            const $form = $(this);
            const $details = $form.find('.change-order-details');
            let emailOrTelephoneChanged;

            if (Outcome === 'Success') {
                emailOrTelephoneChanged = $form.data(EMAIL_OR_TELEPHONE_CHANGED);
                updateEmailAndTelephone();

                // Update *original* data values
                const $emailInput = $details.find('.email-address-editor input');
                $emailInput.data('original-email', EmailAddress);

                const $telephoneInput = $details.find('.telephone-editor input');
                $telephoneInput.data('original-telephone', Telephone);

                const $callingCodeInput = $details.find('.telephone-editor select');
                $callingCodeInput.data('original-callingcode', CallingCode);

                showSuccess();
            } else {
                showError();
            }

            function updateEmailAndTelephone() {
                if (emailOrTelephoneChanged) {
                    $form.data(EMAIL_OR_TELEPHONE_CHANGED, false);
                    $details.find('.email-address-field, .email-address')
                        .text(EmailAddress);
                    $details.find('.telephone-field, .telephone')
                        .text(CompleteTelephone);
                    toggleEmailAndTelephoneEditing($form);
                }
            }

            function showSuccess() {
                $details.closest('.update-order-row').toggleClass('update-successful', true);
            }

            function showError() {
                $details.closest('.update-order-row').toggleClass('update-failed', true);
                console.error(Message);
            }
        }
    });

    function toggleEmailAndTelephoneEditing($el) {
        const $row = $el.closest('.update-order-row');
        const selector = [
            '.action-button-wrapper',
            '.email-address-editor',
            '.email-address-field',
            '.email-address',
            '.telephone-editor',
            '.telephone-field',
            '.telephone'
        ].join(', ');

        const $emailInput = $row.find('.email-address-editor input');
        $emailInput.val($emailInput.data('original-email'));
        const validationClasses = 'is-valid is-invalid error valid';
        $emailInput.focusout().removeClass(validationClasses); // Clears validation state

        const $telephoneInput = $row.find('.telephone-editor input');
        $telephoneInput.val($telephoneInput.data('original-telephone'));
        $telephoneInput.focusout().removeClass(validationClasses); // Clears validation state

        const $callingCodeInput = $row.find('.telephone-editor select');
        $callingCodeInput.val($callingCodeInput.data('original-callingcode'));
        $callingCodeInput.focusout().removeClass(validationClasses); // Clears validation state

        $row.find(selector).toggle();

        // Expand panel and hide messages
        $el.closest('.update-order-row-panel').removeClass('panel-collapsed');
        $row.removeClass('update-successful');
        $row.removeClass('update-failed');
    }
}
